export default class Log {
  id: number;
  mensagem: string;
  d_E_L_E_T_E: boolean;
  criadoEm: Date;
  excluidoEm: Date;

  constructor(
    id?: number,
    mensagem?: string,
    d_E_L_E_T_E?: boolean,
    criadoEm?: Date,
    excluidoEm?: Date
  ) {
    this.id = id  ?? 0;
    this.mensagem = mensagem ?? "";
    this.d_E_L_E_T_E = d_E_L_E_T_E ?? false;
    this.criadoEm = criadoEm ?? new Date();
    this.excluidoEm = excluidoEm ?? new Date();
  }

  mensagemAlteracaoForecastDiario(
    usuarioID: number,
    skuId: string,
    centroId: string,
    idForecastDiarioAtual: string,
    idForecastDiarioAlvo: string,
    quantidade: number
  ): void {
    let dataAgoraFormatada = new Date().toLocaleDateString("pt-BR", { hour: "2-digit", minute: "2-digit" });
    this.mensagem = `Usuário ${usuarioID} moveu a quantidade total de ${quantidade} do SKU ${skuId} do centro ${centroId} do Forecast de ID ${idForecastDiarioAtual} para o Forecast de ID ${idForecastDiarioAlvo}, em ${dataAgoraFormatada}`;
  }

  static toJson(log: Log): string {
    return JSON.stringify(log);
  }

  static fromJson(json: object[]): Log[] {
    let logArr: Log[] = [];
    json.forEach((item: any) => {
      logArr.push(
        new Log(
          item["id"],
          item["mensagem"],
          item["d_E_L_E_T_E"],
          new Date(item["criadoEm"]),
          new Date(item["excluidoEm"])
        )
      );
    });
    return logArr;
  }
}
